import { render, staticRenderFns } from "./PenaltyFreeMobile.vue?vue&type=template&id=0283c39b&scoped=true"
import script from "./PenaltyFreeMobile.vue?vue&type=script&lang=js"
export * from "./PenaltyFreeMobile.vue?vue&type=script&lang=js"
import style0 from "./PenaltyFreeMobile.vue?vue&type=style&index=0&id=0283c39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283c39b",
  null
  
)

export default component.exports